import type { HarmonyPackageFolder } from '@rhythmic/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { useLiveQuery } from '@tanstack/vue-db'
import { getHarmonyFolderCollection } from '../contexts'

export function useFoldersByHarmonyPlanId(
  planId: string | null | undefined,
): UseLiveQueryReturn<HarmonyPackageFolder> | undefined {
  if (!planId) return undefined

  const collection = getHarmonyFolderCollection(planId)
  return useLiveQuery((q) => q.from({ t: collection }).orderBy(({ t }) => (t as any).created_at ?? '', 'asc'))
}
